import { Box, HStack, Tooltip } from '@chakra-ui/react';
import type { Editor } from '@tiptap/core';
import { BubbleMenu } from '@tiptap/react';
import {
  ArrowDownToLine,
  ArrowLeftToLine,
  ArrowRightToLine,
  ArrowUpToLine,
  TableColumnsSplitIcon,
  TableRowsSplitIcon,
  Trash2,
} from 'lucide-react';
import { FormatButton } from './FormatButton';

function TableButton({
  label,
  icon,
  onClick,
}: {
  label: string;
  icon: React.ElementType;
  onClick: () => void;
}) {
  return (
    <Tooltip label={label} placement="top" hasArrow openDelay={300}>
      <span>
        <FormatButton label={label} icon={icon} onClick={onClick} isActive={false} />
      </span>
    </Tooltip>
  );
}

export function TableBubbleMenu({ editor }: { editor: Editor | null }) {
  if (!editor || !editor.isEditable) {
    return null;
  }

  return (
    <BubbleMenu
      editor={editor}
      tippyOptions={{
        placement: 'top',
        offset: [0, 10],
      }}
      shouldShow={() => editor.isActive('table')}
    >
      <HStack
        gap={0.5}
        bg="bg.surface"
        shadow="sm"
        outline="1px"
        p={0.5}
        borderRadius="md"
        borderWidth="1px"
        boxShadow="sm"
      >
        <TableButton
          label="Insert row above"
          icon={ArrowUpToLine}
          onClick={() => editor.chain().focus().addRowBefore().run()}
        />
        <TableButton
          label="Insert row below"
          icon={ArrowDownToLine}
          onClick={() => editor.chain().focus().addRowAfter().run()}
        />
        <TableButton
          label="Remove row"
          icon={TableRowsSplitIcon}
          onClick={() => editor.chain().focus().deleteRow().run()}
        />
        <Box bgColor="border.default" h="32px" w="2px" />
        <TableButton
          label="Insert column left"
          icon={ArrowLeftToLine}
          onClick={() => editor.chain().focus().addColumnBefore().run()}
        />
        <TableButton
          label="Insert column right"
          icon={ArrowRightToLine}
          onClick={() => editor.chain().focus().addColumnAfter().run()}
        />
        <TableButton
          label="Remove column"
          icon={TableColumnsSplitIcon}
          onClick={() => editor.chain().focus().deleteColumn().run()}
        />
        <Box bgColor="border.default" h="32px" w="2px" />
        <TableButton
          label="Delete table"
          icon={Trash2}
          onClick={() => editor.chain().focus().deleteTable().run()}
        />
      </HStack>
    </BubbleMenu>
  );
}
